'use client';

import './home-mobile.scss';
import { useEffect, useRef } from 'react'
import { SentenceScramble } from "@/lib/utils/SentenceScramble";
import { useSwiperSlide } from 'swiper/react';

export default function LoadingCapabilities() {
  const swiperSlide = useSwiperSlide();
  const hasScrambledOnce = useRef(false); // persists across renders

  useEffect(() => {
    if (swiperSlide.isActive && !hasScrambledOnce.current) {
      const sentenceScrambler = new SentenceScramble('loading-capabilities-scrambler');
      sentenceScrambler.startSequentialScramble(0.1);
      hasScrambledOnce.current = true;
    }
  }, [swiperSlide?.isActive]);

  useEffect(() => {
    const handleScroll = (e: Event) => {
      e.preventDefault();
    };

    document.body.style.overflow = 'hidden';
    window.addEventListener('scroll', handleScroll, { passive: false });

    return () => {
      document.body.style.overflow = 'auto';
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const _renderContentItem1 = () => {
    return (
      <div>
        <h2 className='text-gray loading-capabilities-scrambler'>{`< Loading Capabilities >`}</h2>
        <ul>
          <li className="loading-capabilities-scrambler">{'< loading > creative direction : OK'}</li>
          <li className="loading-capabilities-scrambler">{'< loading > branding design: OK'}</li>
          <li className="loading-capabilities-scrambler">{'< loading > interaction design : OK'}</li>
          <li className="loading-capabilities-scrambler">{'< loading > character design : OK'}</li>
          <li className="loading-capabilities-scrambler">{'< loading > motion design : OK'}</li>
          <li className="loading-capabilities-scrambler">{'< loading > production : OK'}</li>
          <li className="loading-capabilities-scrambler">{'< loading > front-end : OK'}</li>
          <li className="loading-capabilities-scrambler">{'< loading > back-end : OK'}</li>
          <li className="loading-capabilities-scrambler">{'< loading > ui.ux : OK'}</li>
          <li className="loading-capabilities-scrambler">{'< loading > web 3.0 : OK'}</li>
        </ul>  
        <p className='text-gray' aria-hidden="true">{'<>'}</p>
      </div>
    )
  };

  const _renderContentItem2 = () => {
    return (
      <div>
        <h2 className='text-gray loading-capabilities-scrambler'>{`< Trust The Process >`}</h2>
        <p className="loading-capabilities-scrambler">{'To experiment is to invite challenges,'}</p>
        <p className="loading-capabilities-scrambler">{'and sometimes, chaos.'}</p>
        <br></br>
        <p className="loading-capabilities-scrambler">{"And now, we're inviting you to the lab"}</p>
        <p className="loading-capabilities-scrambler">{"to watch it all happen. "}</p>
        <p className='text-gray'>{'<>'}</p>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
          <span className="loading-capabilities-scrambler">{'Awaiting next steps ...'}</span>
          <span className="span-text-loading">{'>>>'}</span>
        </div>
      </div>
    )
  };

  return (
    <div className={'div-loading-container'}>
      <div className={`loading-first-mobile`}>
        {_renderContentItem1()}
        {_renderContentItem2()}
      </div>
    </div>
  )
};